import { ErrorData } from 'domain/types';
import Widget from 'domain/entity/widget';
import { Option } from 'fp-ts/lib/Option';
import React, { createContext, ReactElement, useContext } from 'react';
import { CriteriaCallback, useCase } from 'adapter/in/common/hooks/useCase';
import { ReadWidgets } from 'use-case/widgets/read/readWidgetsUseCase';

export type WidgetsError = Option<ErrorData>;
export type Widgets = Option<Widget[]>;

export type WidgetsReadData = {
    read: CriteriaCallback;
    readIsLoading: boolean;
    readResult: Widgets;
    readError: WidgetsError;
    readReset: () => void;
};
export type WidgetsProvider = {
    readWidgets: ReadWidgets;
    children: ReactElement;
};

export const WidgetsContext = createContext({} as WidgetsReadData);

export const useWidgets = (): WidgetsReadData => useContext(WidgetsContext);

export const WidgetsProvider = (props: WidgetsProvider): ReactElement => {
    const { children, readWidgets } = props;

    const { isLoading: readIsLoading, data: readResult, error: readError, execute: read, reset: readReset } = useCase(readWidgets, false);

    return (
        <WidgetsContext.Provider
            value={{
                read,
                readIsLoading,
                readResult,
                readError,
                readReset,
            }}
        >
            {children}
        </WidgetsContext.Provider>
    );
};
